export default {
  data() {
    return {};
  },

  computed: {
    isYoutube() {
      if (!this.isVideo || this.isCloudflareVideo) {
        return false;
      }

      if (this.isDesktop && this.interaction.mediaDesktop) {
        if (
          this.interaction.mediaDesktop.includes("youtube") ||
          this.interaction.mediaDesktop.includes("youtu.be")
        ) {
          return true;
        }
      } else if (this.interaction.mediaMobile) {
        if (
          this.interaction.mediaMobile.includes("youtube") ||
          this.interaction.mediaMobile.includes("youtu.be")
        ) {
          return true;
        }
      }

      return false;
    },

    isVideo() {
      return this.interaction ? this.interaction.tipo === "VIDEO" : false;
    },

    isCloudflareVideo() {
      return this.interaction.isCloudflareVideo;
    },
  },

  methods: {
    getVideoId(url) {
      let formattedUrl = url;
      if (formattedUrl.includes("&t=")) {
        formattedUrl = formattedUrl.split("&t=")[0];
      }
      return this.getYoutubeVideoId(formattedUrl);
    },

    getYoutubeVideoId(url) {
      let videoId;
      if (url.includes("/shorts/")) {
        videoId = url.includes("?feature=")
          ? url.split("/shorts/")[1].split("?feature=")[0]
          : url.includes("?si=")
          ? url.split("/shorts/")[1].split("?si=")[0]
          : url.split("/shorts/")[1];
      } else if (url.includes("youtu.be")) {
        videoId = url.includes("?feature=")
          ? url.split("youtu.be/")[1].split("?feature=")[0]
          : url.split("https://youtu.be/")[1].split("?si=")[0];
      } else {
        videoId = url.split("?v=")[1].split("&")[0];
      }
      return videoId;
    },
  },
};
